import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default (state: boolean) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      padding: 15,

      '& .MuiGrid-container': {
        alignItems: 'center',
      },
    },
    tableRow: {
      width: 100,
      paddingRight: 0,
      paddingLeft: 16,
      fontSize: 12,
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
    state: {
      width: 80,
      fontSize: 12,
    },
    buttons: { marginTop: 15 },
    switchContainer: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 8,
    },
    switchChecked: {
      '&.Mui-checked': {
        color: palette.green,

        '& + .MuiSwitch-track': {
          backgroundColor: palette.green,
        },
      },
    },
    switchText: {
      fontSize: 12,
      fontWeight: 500,
      color: state ? palette.darkGreen : palette.darkRed,
    },
    activeAllText: {
      fontSize: 15,
      fontWeight: 500,
    },
    checkboxCell: {
      width: '10%',
      padding: '0 0 0 8px',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },
    checkboxActivateAll: {
      '& .MuiCheckbox-colorSecondary.Mui-checked': {
        color: state ? palette.green : palette.red,
      },
    },
  });

export const overrideSwitch = (state): any => ({
  switchContainer: {
    marginBottom: 16,
    padding: 0,
    justifyContent: 'center',
    '& .MuiFormControlLabel-root': {
      marginRight: 0,
      paddingRight: 16,
      backgroundColor: state ? palette.superLightGreen : palette.superLightRed,
      borderRadius: 25,
    },
    '& .MuiSwitch-track': {
      backgroundColor: ` ${
        state ? palette.darkGreen : palette.darkRed
      } !important`,
      opacity: '0.4 !important',
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: state ? palette.darkGreen : palette.darkRed,
    },
  },
});
